import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Initializes Preline UI JS plugins on every route change.
 * Must be rendered inside a RouterProvider context.
 */
export function PrelineLoader() {
  const location = useLocation();

  useEffect(() => {
    const init = async () => {
      const { HSStaticMethods } = await import('preline/dist/index.js');
      HSStaticMethods.autoInit();
    };
    init();
  }, [location.pathname]);

  return null;
}
